export default __webpack_public_path__ + "static/media/pink-lambo.cf493f82.svg";